import type { FC } from 'react';

export const DashedLine: FC<{ color: string }> = ({ color }) => (
  <svg width="13" height="2" viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.4365 1L0.436523 1" stroke={color} strokeWidth="1.5" strokeDasharray="2 2" />
  </svg>
);
